<div class="avatar" [ngStyle]="{ 'background-image': 'url('+getUrl()+ ')'}" [ngClass]="{'no_img': isImg == false}">
    <span *ngIf="isImg == false" class="letter">{{getName()}}</span>
</div>